<template>
  <transition name="fade">
    <div class="scroll-to-top" @click="scrollToTop">
      <div class="scroll-to-top-button" >
        <img class="btnimg" src="../../static/img/up.png" alt="">
      </div>
      <div class="scroll-to-top-text">回到顶部</div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false, // 按钮默认隐藏
      threshold: 600, // 滚动超过多少距离时显示按钮
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // console.log(window.pageXOffset)
      // 判断页面滚动距离，决定是否显示按钮
      this.isVisible = window.pageYOffset > this.threshold;
    },
    scrollToTop() {
      // 平滑滚动回页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
.scroll-to-top-button {
  background-color: #ffffff;
  color: white;
  border: 1px solid #aaa;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 50px;
  min-width: 50px;
  min-height: 50px;
  height: 50px;
  cursor: pointer;
  z-index: 1000;
}
.btnimg{
  width: 40px;
  height: 40px;
}
.scroll-to-top{
  position: fixed;
  bottom: 120px;
  right: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.scroll-to-top-text{
  display: flex;
  justify-content: center;
  color: #333;
  font-size: 14px;
  margin-top: 10px;
  cursor: pointer;
  background-color: #ffffff;
  padding: 2px 6px;
  border-radius: 5px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ScrollToTopButton.vue